import { render, staticRenderFns } from "./DepartmentManagerList.vue?vue&type=template&id=90c38962"
import script from "./DepartmentManagerList.vue?vue&type=script&lang=ts"
export * from "./DepartmentManagerList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports